// ATTN we use these constants in data dump
const abTests = {
  upchargeInfoPayment: 'UpchargeInfoPayment', // PF-1397
  mainStorylyForLeads: 'main:storylyForLeads', // CRO-191
  mainSubscribersCount: 'main:subscribersCount', // CRO-186
  homeQueueWidget: 'home:queueWidget', // CRO-51
  inAppMessagesCenter: 'inAppMessagesCenter', // CRO-69
  paymentRegisterInPayment: 'payment:registerInPayment', // CRO-148
  paymentPlanSelection: 'payment:planSelection', // CRO-164
  paymentPaymentMethodsOrder: 'payment:paymentMethodsOrder', // CRO-241
  homeNewHowItWorks: 'home:newHowItWorks', // CRO-189
  homeStickyVideo: 'home:stickyVideo', // CRO-212
  homeQuizSectionBottlesAnimation: 'home:quizSectionBottlesAnimation', // CRO-259
  homeCopyUpdate: 'home:copyUpdate', // CRO-216
  homePerfumeSubscriptionKeyword: 'home:perfumeSubscriptionKeyword', // CRO-236
  homeSubscriptionOfferBadge: 'home:subscriptionOfferBadge', // CRO-181
  homeSelectBlock: 'home:selectBlock', // CRO-202
  spResultsPageUpdate2: 'sp:resultsPageUpdate2', // CRO-260
  spResultsPageBestsellers: 'sp:resultsPageBestsellers', // CRO-128
  spRecommendedProductsCardUpdate: 'sp:recommendedProductsCardUpdate', // CRO-245
  spStepsFlow: 'sp:stepsFlow', // CRO-265
  upgradeCardNewDesign: 'upgrade:cardNewDesign', // CRO-229
  quizNotesAnimation: 'quiz:notesAnimation', // CRO-250
  tyCaseSubscription: 'ty:caseSubscription', // CRO-258
  queueStickyBanner: 'queue:stickyBanner', // EP-2100
  queueCaseSubscriptionBanner: 'queue:CaseSubscriptionBanner', // EP-2123
  profileCaseSubscriptionButton: 'profile:caseSubscriptionButton', // CRO-272
  cancelButton: 'cancelButton25', // EP-2144
  csBadge: 'cs:badge', // EP-2219
  burgerMenu: 'burgerMenu', // EP-2241
  homeCanada50vs60: 'home:canada50vs60', // EP-2181
  upgradeEntryPoints: 'upgradeEntryPoints', // EP-2237
  burgerMenuBannersForLeads: 'burgerMenuBannersForLeads', // EP-2242
  burgerMenuBannersForActive: 'burgerMenuBannersForActive', // EP-2242
  upgradePopup: 'upgradePopup', // EP-2262
  cloudinary: 'cloudinary', // EP-2290
  driftbrandpage: 'driftbrandpage', // PF-1766
  navScentHoroscopeInPerfumes: 'nav:scentHoroscopeInPerfumes', // EP-2364
  caseUpsellOptions12vs3: 'caseUpsellOptions12vs3', // EP-2419
  limitedDropsCheckoutRedirect: 'limitedDropsCheckoutRedirect', // PF-2107
} as const

export type AbTestName = typeof abTests[keyof typeof abTests]


export default abTests
